function Trackable({ children }) {
	return <>{children}</>;
}

export default Trackable;
